export default __webpack_public_path__ + "static/0214-da5848b5b8906a647cbd9260481d80fa.png";